import { gsap } from 'gsap'

if($('.block-404').length) {

  $(window).on('load', function () {
    gsap.to('.block-404 .image-container', { scale: 1, duration: 1 })
  })

}
